module.exports = __webpack_public_path__ + "img/winning-eggs.da71cc62.webp";